<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M11.9928,4.99715C11.9928,4.44747,11.5431,3.99774,10.9934,3.99774C10.7135,3.99774,10.4637,4.10768,10.2838,4.28757C10.2838,4.28757,7.99517,6.5862,7.99517,6.5862C7.99517,6.5862,5.70654,4.29756,5.70654,4.29756C5.52664,4.10768,5.27679,3.99774,4.99696,3.99774C4.44729,3.99774,3.99756,4.44747,3.99756,4.99715C3.99756,5.27698,4.10749,5.52683,4.28738,5.70672C4.28738,5.70672,6.57602,7.99536,6.57602,7.99536C6.57602,7.99536,4.28738,10.284,4.28738,10.284C4.10749,10.4639,3.99756,10.7137,3.99756,10.9936C3.99756,11.5432,4.44729,11.993,4.99696,11.993C5.27679,11.993,5.52664,11.883,5.70654,11.7031C5.70654,11.7031,7.99517,9.41451,7.99517,9.41451C7.99517,9.41451,10.2838,11.7031,10.2838,11.7031C10.4637,11.883,10.7135,11.993,10.9934,11.993C11.5431,11.993,11.9928,11.5432,11.9928,10.9936C11.9928,10.7137,11.8829,10.4639,11.703,10.284C11.703,10.284,9.41432,7.99536,9.41432,7.99536C9.41432,7.99536,11.703,5.70672,11.703,5.70672C11.8829,5.52683,11.9928,5.27698,11.9928,4.99715C11.9928,4.99715,11.9928,4.99715,11.9928,4.99715ZM7.99523,0C3.57787,0,0,3.57787,0,7.99523C0,12.4126,3.57787,15.9905,7.99523,15.9905C12.4126,15.9905,15.9905,12.4126,15.9905,7.99523C15.9905,3.57787,12.4126,0,7.99523,0C7.99523,0,7.99523,0,7.99523,0ZM7.99572,13.9918C4.68769,13.9918,1.9993,11.3034,1.9993,7.99536C1.9993,4.68733,4.68769,1.99893,7.99572,1.99893C11.3037,1.99893,13.9921,4.68733,13.9921,7.99536C13.9921,11.3034,11.3137,13.9918,7.99572,13.9918C7.99572,13.9918,7.99572,13.9918,7.99572,13.9918Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Delete',
} as DefineComponent
</script>
